/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */

import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type Size = 'sm' | 'md' | 'lg';
type Variant = 'solid' | 'ghost';
type IconPosition = 'start' | 'end' | null;
type bp = 'sm' | 'md' | 'lg';

@Component({
    selector: '[luiCab]',
    template: `
    <span class="lui-cab-container" #trigger>
      <span
        class="lui-cab-icon-container"
        matRipple
        [matRippleTrigger]="trigger"
      >
        <ng-content select="mat-icon"></ng-content>
      </span>
      <span class="lui-cab-text-container">
        <ng-content></ng-content>
      </span>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Cab {
  private _model = 'lui-cab';
  @HostBinding('class') get hostClasses() {
    return {
      [this._model]: true,
      [`${this._model}-${this.size}`]: true,
      [`${this._model}-${this.variant}`]: true,
      [`${this._model}-icon-${this.iconPosition}`]: this.iconPosition !== null,
      [`${this._model}-hide-text-until-${this.hideTextUntil}`]:
        this.iconPosition !== null,
    };
  }

  @Input() size: Size = 'md';
  @Input() variant: Variant = 'solid';
  @Input() iconPosition: IconPosition = null;
  @Input() hideTextUntil: bp | null = null;
  @Input() disabled = false;

  @HostBinding('attr.data-disabled') get disabledAttr() {
    return this.disabled || null;
  }
}
